const paperStyles = (theme) => ({
  [theme.breakpoints.up("md")]: {
    padding: " 16px",
    marginX: "0px",
    maxWidth: "280px",
    "& .MuiTab-root.Mui-selected": {
      background: "#E1EFB0",
      width: 1,
      justifyContent: "flex-start",
    },
  },
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
  marginX: "auto",
});

const buttonStyles = (theme) => ({
  m: 1,
  [theme.breakpoints.up("md")]: {
    marginBottom: "20px",
    // marginX: "20px",
    borderRadius: "4px",
  },
  fontFamily: "Poppins",
  //  minWidth: "150px",
});

const tabStyles = (theme) => ({
  [theme.breakpoints.up("md")]: {
    alignSelf: "start",
    minHeight: "30px",
    width: 1,
    justifyContent: "flex-start",
  },
  minHeight: "50px",
  color: "#212B36",
});

export { paperStyles, buttonStyles, tabStyles };
